// extracted by mini-css-extract-plugin
export default {"H2Header":"fYdcwjpzZGr6fUkHTq0w"};